<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Project Progress
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-form
          ref="form"
          v-model="valid"
        >
          <div class="progress-linear-style">
            <v-progress-linear
              v-model="currentProjectProgress"
              height="40"
              color="#BDBDBD"
              light
              rounded
            >
              <strong>{{ Math.ceil(currentProjectProgress) }}%</strong>
            </v-progress-linear>
          </div>
          <br>
          <v-text-field
            v-model="updatedProjectProgress"
            dense
            filled
            hint="Project progress value."
            persistent-hint
            class="field-text-style"
            inputmode="numeric"
            color="#000000"
            light
            outlined
            label="Update Project Progress*"
          />
        </v-form>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="projectProgressGathered()"
    >
      Next
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  export default {
    name: 'GatherProjectProgress',
    components: {
      'centre-spinner': spinner,
    },
    data: () => ({
      loading: false,
      valid: false,
      updatedProjectProgress: null,
      currentProjectProgress: 0,
    }),
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
    },
    mounted () {
      this.loading = true;
      setTimeout(() => {
        this.currentProjectProgress = this.activeCheckInDetails.project.project_progress;
        this.updatedProjectProgress = this.activeCheckInDetails.project.project_progress;
        this.loading = false;
      }, 1000);
    },
    methods: {
      projectProgressGathered () {
        if (this.updatedProjectProgress === null || this.updatedProjectProgress === '') {
          this.$store.dispatch('alert/onAlert', {
            message: 'Project progress value should not be left empty.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (parseInt(this.updatedProjectProgress) < parseInt(this.currentProjectProgress)) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Updated progress value should be always greater than current value.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        if (parseInt(this.updatedProjectProgress) > 100) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Updated progress value should not be greater than 100.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        this.$store.dispatch('swiftuser/saveProjectProgress', this.updatedProjectProgress);
        setTimeout(() => {
          this.loading = false;
          this.$emit('project-progress-stored');
        }, 1000);
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckOut' });
        }, 1000);
      },
    },
  };
</script>
